<div class="header">
  <h3>Notes and History</h3>
  <button type="button" class="text-uppercase" mat-button (click)="onClose()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<h3 *ngIf="!histories?.length" class="no-results">No results found.</h3>
<div class="content">
  <div *ngFor="let history of histories" class="item">
    <ng-container *ngIf="isHistoryNote(history) as note">
      <mat-icon class="pr-1" *ngIf="note.title">history</mat-icon>
      <mat-icon class="pr-1" *ngIf="!note.title">comment</mat-icon>
      <div fxFlex="grow" fxLayout="column" fxLayoutGap="10px">
        <div class="info-row">
          <span class="title">
            {{ note.title || note.description }}
          </span>
          <span>
            {{ history.happenedOn | date: 'medium' }}
          </span>
        </div>
        <div *ngIf="note.title">
          {{ note.description }}
        </div>
        <div *ngIf="note.noteActionType === 'CompletePersonRequirement'" class="note-complete">
          [Requirement marked complete]
        </div>
        <div class="note-info">by: {{ history.actor }}</div>
      </div>
    </ng-container>
    <ng-container *ngIf="isHistoryUpdate(history) as update">
      <mat-icon class="pr-1">history</mat-icon>
      <div fxFlex="grow" fxLayout="column" fxLayoutGap="10px">
        <div class="info-row">
          <span class="title">
            {{ updateTitle(update) }}
          </span>
          <span>
            {{ history.happenedOn | date: 'medium' }}
          </span>
        </div>
        <div
          class="limit-width"
          *ngFor="let property of update.properties"
          [innerHTML]="propertyDescription(update.stateName, property)"
        ></div>
        <div class="note-info">by: {{ history.actor }}</div>
      </div>
    </ng-container>
  </div>
</div>
